import React from "react";
import { PeekBox, PeekDivider, PeekPaper, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import { ReportTypeAction, ReportTypeDescription, ReportTypeHeader, ReportTypeList, ReportTypeTitle } from "./content";
export const ReportTypeBox = ({ reportType, onSelect, onPreview }) => {
    return (React.createElement(PeekPaper, { elevation: 1, sx: {
            overflow: "hidden",
            width: "100%",
            minWidth: "370px",
            border: reportType.recommendedLabel ? "1px solid" : "none",
            borderColor: reportType.recommendedLabel ? "secondary.main" : "transparent",
        } },
        reportType.recommendedLabel && (React.createElement(PeekBox, { sx: { bgcolor: "secondary.main", p: 0.75 } },
            React.createElement(PeekTypography, { variant: "h4", textAlign: "center", color: "common.white", fontWeight: "fontWeightLight" }, reportType.recommendedLabel))),
        React.createElement(PeekStack, { direction: "column", gap: 3, padding: 2.5 },
            React.createElement(ReportTypeHeader, { reportType: reportType }),
            React.createElement(ReportTypeTitle, { reportType: reportType }),
            React.createElement(ReportTypeDescription, { reportType: reportType }),
            React.createElement(ReportTypeAction, { reportType: reportType, onSelect: onSelect, onPreview: onPreview }),
            React.createElement(PeekDivider, { light: true }),
            React.createElement(ReportTypeList, { reportType: reportType }))));
};
export default ReportTypeBox;
